import URI from 'legacy/defaults/RoutesDefault';
import { clearUserData } from 'legacy/utilities/Auth';

export const logUserOutAndRedirectToLogin = () => {
	clearUserData();
	window.location.assign(`${URI.login.base}?loggedOut=true`);
};
